module.exports = __webpack_public_path__ + "static/media/Pin-Dark-Moto.2e7c14c9.svg";